document.addEventListener('DOMContentLoaded',  () => {
    window.addEventListener('scroll', () => {
        const faixa = document.querySelector('.container-faixa-text-icon-main');
        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        if (scrollTop + windowHeight >= documentHeight - 5) {
            faixa.classList.add('hidden-faixa');
        } else {
            faixa.classList.remove('hidden-faixa');
        }
    });
});